export default "__VITE_ASSET__Byun$GdR__"